module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-diziani-7e4f061cea656f24405a0b45d4d471d1.png";